import { Lightning, Utils } from '@lightningjs/sdk'

export default class ArrowButton extends Lightning.Component {
  static _template() {
    return {
      w: 138,
      h: 46,
      Button: { w: 46, h: 46, src: this.bindProp('buttonImage') },
    }
  }

  set buttonType(tp) {
    this._butnType = tp

    if (tp.toLowerCase() === 'left' || tp.toLowerCase() === 'right') {
      this.buttonNormal = `images/buttons/Arrow${tp.charAt(0).toUpperCase() + tp.slice(1)}.png`
      this.buttonFocus = `images/buttons/Arrow${tp.charAt(0).toUpperCase() + tp.slice(1)}F.png`

      this.patch({ buttonImage: Utils.asset(this.buttonNormal) })
    }
  }

  get type() {
    return this._butnType
  }

  _focus() {
    this.patch({ buttonImage: Utils.asset(this.buttonFocus) })
  }

  _unfocus() {
    this.patch({ buttonImage: Utils.asset(this.buttonNormal) })
  }
}
